var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "discover",
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.273,
    height: 39.999,
    viewBox: "0 0 62.273 39.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8408",
    "data-name": "Path 8408",
    d: "M4.39,0A4.391,4.391,0,0,0,0,4.391V35.608A4.391,4.391,0,0,0,4.39,40H57.883a4.391,4.391,0,0,0,4.39-4.391V4.391A4.391,4.391,0,0,0,57.883,0Z",
    transform: "translate(0)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8409",
    "data-name": "Path 8409",
    d: "M88.151,161.893a4.4,4.4,0,0,1,2.017.486V164.2a2.826,2.826,0,0,0-2.056-.891,2.709,2.709,0,0,0-2.748,2.719,2.667,2.667,0,0,0,2.824,2.73,2.7,2.7,0,0,0,1.98-.867V169.7a4.769,4.769,0,0,1-2.056.461,4.235,4.235,0,0,1-4.438-4.131A4.3,4.3,0,0,1,88.151,161.893Zm-7.753.05a3.813,3.813,0,0,1,2.47.878l-.858,1.058a1.734,1.734,0,0,0-1.322-.641c-.707,0-1.222.379-1.222.877,0,.427.289.654,1.273,1,1.865.642,2.418,1.212,2.418,2.469a2.642,2.642,0,0,1-2.9,2.6,3.32,3.32,0,0,1-2.911-1.507l1.059-.96a1.954,1.954,0,0,0,1.79,1.056,1.17,1.17,0,0,0,1.273-1.116.937.937,0,0,0-.492-.819,6.77,6.77,0,0,0-1.134-.451c-1.54-.522-2.069-1.08-2.069-2.17A2.413,2.413,0,0,1,80.4,161.943Zm18.74.138h1.791l2.242,5.317,2.271-5.317h1.778l-3.632,8.118h-.882l-3.568-8.118Zm-31.724.012h2.407c2.66,0,4.514,1.627,4.514,3.963a3.885,3.885,0,0,1-1.526,3.038,4.556,4.556,0,0,1-3,.914H67.414Zm7.675,0h1.64v7.915h-1.64Zm32.872,0h4.651v1.341H109.6v1.757h2.9v1.341h-2.9v2.137h3.012v1.34h-4.651v-7.915Zm5.737,0h2.431c1.891,0,2.975.855,2.975,2.337a2.139,2.139,0,0,1-1.915,2.244l2.646,3.335H117.82l-2.27-3.18h-.214v3.18H113.7Zm1.638,1.247v2.4h.479c1.047,0,1.6-.428,1.6-1.224,0-.77-.555-1.173-1.576-1.173Zm-46.284.094v5.234h.44a3.24,3.24,0,0,0,2.244-.629,2.644,2.644,0,0,0,.908-1.994,2.6,2.6,0,0,0-.908-1.97,3.168,3.168,0,0,0-2.244-.64Z",
    transform: "translate(-62.032 -148.968)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8410",
    "data-name": "Path 8410",
    d: "M236.711,161.209a4.346,4.346,0,0,1,4.473,4.208v0a4.481,4.481,0,0,1-8.945,0v0a4.346,4.346,0,0,1,4.473-4.208Zm29.129,10.151c-2.08,1.463-17.651,11.923-44.61,16.975h40.219a4.391,4.391,0,0,0,4.39-4.391V171.36Z",
    transform: "translate(-203.567 -148.338)",
    fill: "#f47216",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.6a90b54e63bda8ad91e56f407c7a5d17.svg";
export { ForwardRef as ReactComponent };